module.exports = __webpack_public_path__ + "static/media/TPS-Logo.ba7bdf22.png";